const items = [
  {
    href: '/pld/alerts',
    title: 'alerts',
  },
  // {
  //   href: '/pld/warning/models/unusual',
  //   title: 'Inusuales',
  // },
  // {
  //   href: '/pld/warning/models/unusual/fractional',
  //   title: 'Inusuales fraccionadas',
  // },
  // {
  //   href: '/pld/warning/models/unusual/transactional',
  //   title: 'Inusuales transaccionadas',
  // },
  // {
  //   href: '/pld/warning/models/worrisome',
  //   title: 'Preocupantes',
  // },
  // {
  //   href: '/pld/warning/models/relevant',
  //   title: 'Relevantes',
  // },
  {
    href: '/pld/customer_accounts',
    title: 'customer_accounts',
  },
  {
    href: '/pld/complaints',
    title: 'complaints',
  },
  {
    href: '/pld/research_cases',
    title: 'research_cases',
  },
];

export default items;
